export default "__VITE_ASSET__D45kbUyQ__"